import update from 'immutability-helper';

import {ErrorState, ErrorActionType} from './types';
import {SET_ERROR_MESSAGE, CLEAR_ERROR_MESSAGE} from './actions';

const initialState: ErrorState = {
  needLogin: false,
};

export default function errorReducer(
  state = initialState,
  action: ErrorActionType
): ErrorState {
  const {type, payload} = action;

  switch (type) {
    case SET_ERROR_MESSAGE:
      return update(state, {
        $merge: payload,
      });
    case CLEAR_ERROR_MESSAGE:
      return update(state, {
        $merge: {
          status: undefined,
          message: undefined,
          cause: undefined,
        },
      });
    default:
      return state;
  }
}
